<template>
  <div id="main" class="d-flex align-items-center">
    <ul class="nav">
      <li class="nav-item">
        <span class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          ピッキング
        </span>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li><a class="dropdown-item" href="/barcode_import">アップロード</a></li>
          <li><a class="dropdown-item" href="/barcode_list">一覧</a></li>
        </ul>
      </li>

      <li class="nav-item">
        <span class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          ヤフオクUP
        </span>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li><a class="dropdown-item" href="/putup_upload">アップロード</a></li>
          <li><a class="dropdown-item" href="/putup_list">一覧</a></li>
          <li><a class="dropdown-item" href="/putup_download_list">ダウンロード</a></li>
        </ul>
      </li>

    </ul>
  </div>
</template>

<style lang="scss" scoped>
#main {
  position: relative;
  left: 20%;
  width: 40%;
  height: 100%;
  font-size: large;
  font-weight: bold;

  li.nav-item {
    margin-left: 3rem;
    :hover{
      border-bottom: 2px solid #0070ba;
    }
  }
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
